import { httpClient } from '../../httpClient/httpClient';

export interface TargetTier {
  id: number;
  quantity: number;
}

export interface TargetTierInfo {
  articleId: number;
  id: number;
  vdcArticle: boolean;
  targetTiers: TargetTier[];
}

export interface RecommendedTargetTier {
  quantity: number;
  count: number;
}

export const targetTiersApi = {
  recommended: (articleId: number) =>
    httpClient.get<RecommendedTargetTier[]>(
      `target-tiers/${articleId}/recommended`,
    ),
  getInfo: (articleId: number) =>
    httpClient.get<TargetTierInfo>(`target-tiers/${articleId}/info`),
  addMultipleTiers: (articleId: number, quantities: number[]) =>
    httpClient.put(`target-tiers/${articleId}/add-multiple`, {
      data: { quantities },
    }),
  addTier: (infoId: number, quantity: number) =>
    httpClient.post(`target-tiers/${infoId}/info/add-tier/${quantity}`),
  removeTier: (tierId: number) =>
    httpClient.delete(`target-tiers/tier/${tierId}`),
  updateTier: (tierId: number, quantity: number) =>
    httpClient.put(`target-tiers/tier/${tierId}/${quantity}`),
};
